var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isOld && _vm.disabled && _vm.editable,
                            expression: "isOld && disabled && editable",
                          },
                        ],
                        attrs: {
                          url: _vm.deleteAuthUrl,
                          isSubmit: _vm.isDeleteAuth,
                          param: _vm.data,
                          mappingType: "PUT",
                          label: "삭제",
                          icon: "delete_forever",
                          auth: "ENV",
                        },
                        on: {
                          beforeAction: _vm.deleteAuth,
                          btnCallback: _vm.deleteAuthCallback,
                        },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isOld &&
                              !_vm.disabled &&
                              _vm.editable &&
                              _vm.isOwner,
                            expression:
                              "isOld && !disabled && editable && isOwner",
                          },
                        ],
                        attrs: { label: "삭제", icon: "delete_forever" },
                        on: { btnClicked: _vm.removePlan },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.disabled && _vm.editable,
                            expression: "!disabled && editable",
                          },
                        ],
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.data,
                          mappingType: _vm.mappingType,
                          label: "임시저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.savePlan,
                          btnCallback: _vm.saveCallback,
                        },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isOld && !_vm.disabled && _vm.editable,
                            expression: "isOld && !disabled && editable",
                          },
                        ],
                        attrs: {
                          url: _vm.updateUrl,
                          isSubmit: _vm.isComplete,
                          param: _vm.data,
                          mappingType: "PUT",
                          label: "완료",
                          icon: "check",
                        },
                        on: {
                          beforeAction: _vm.completePlan,
                          btnCallback: _vm.completeCallback,
                        },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isOld &&
                              _vm.disabled &&
                              _vm.editable &&
                              _vm.isOwner,
                            expression:
                              "isOld && disabled && editable && isOwner",
                          },
                        ],
                        attrs: {
                          url: _vm.updateUrl,
                          isSubmit: _vm.isComplete2,
                          param: _vm.data,
                          mappingType: "PUT",
                          label: "완료취소",
                          icon: "check",
                        },
                        on: {
                          beforeAction: _vm.completePlan2,
                          btnCallback: _vm.completeCallback2,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "순회일",
                        name: "patrolDate",
                      },
                      on: { datachange: _vm.datachangeDate },
                      model: {
                        value: _vm.data.patrolDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "patrolDate", $$v)
                        },
                        expression: "data.patrolDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "순회명",
                        name: "patrolName",
                      },
                      model: {
                        value: _vm.data.patrolName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "patrolName", $$v)
                        },
                        expression: "data.patrolName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-dept", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "점검주관부서",
                        name: "deptCd",
                      },
                      on: {
                        setDeptName: (deptName) => {
                          _vm.data.deptName = deptName
                        },
                      },
                      model: {
                        value: _vm.data.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "deptCd", $$v)
                        },
                        expression: "data.deptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled || _vm.isOld,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      on: { datachange: _vm.datachange },
                      model: {
                        value: _vm.data.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "plantCd", $$v)
                        },
                        expression: "data.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-multi-field", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        data: _vm.data,
                        disabled: _vm.disabled,
                        label: "점검자",
                        type: "user",
                        name: "checkUserId",
                      },
                      model: {
                        value: _vm.data.checkUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "checkUserId", $$v)
                        },
                        expression: "data.checkUserId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        type: "edit",
                        disabled: _vm.disabled,
                        comboItems: _vm.lineItems,
                        editable: _vm.editable,
                        itemText: "lineCd",
                        itemValue: "lineId",
                        label: "라인",
                        name: "lineId",
                      },
                      model: {
                        value: _vm.data.lineId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "lineId", $$v)
                        },
                        expression: "data.lineId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        type: "edit",
                        disabled: _vm.disabled,
                        comboItems: _vm.placeItems,
                        editable: _vm.editable,
                        itemText: "placeName",
                        itemValue: "placeId",
                        label: "장소",
                        name: "placeId",
                      },
                      model: {
                        value: _vm.data.placeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "placeId", $$v)
                        },
                        expression: "data.placeId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "점검항목 목록",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.data.resultList,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                noDataLabel:
                  "점검항목이 없습니다. 점검항목 메뉴에서 사업장별로 항목을 추가하세요.",
                hideBottom: true,
                editable: _vm.editable && !_vm.disabled,
                rowKey: "envPatrolResultId",
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      props.row["sopImprovementIds"] &&
                      props.row["ibmStepNames"]
                        ? _vm._l(
                            _vm.$comm.ibmTagItems(props.row, _vm.colorItems),
                            function (item, index) {
                              return _c(
                                "q-chip",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: item.color,
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.linkClick(item, props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(item.title) + " "),
                                  _c("c-assess-tooltip", {
                                    attrs: {
                                      ibmTooltip: item.ibmTooltip,
                                      ibmClassCd: item.ibmClassCd,
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          )
                        : _vm._e(),
                      _vm.data.envPatrolId
                        ? _c(
                            "div",
                            [
                              _c(
                                "q-btn-group",
                                {
                                  staticClass: "ColumInnerBtnGroup",
                                  attrs: { outline: "" },
                                },
                                [
                                  _vm.editable && !_vm.disabled
                                    ? _c(
                                        "q-btn",
                                        {
                                          staticClass: "ColumInnerBtn",
                                          attrs: {
                                            icon: "add",
                                            color: "red-6",
                                            "text-color": "white",
                                            align: "center",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.innerBtnClicked(
                                                col,
                                                props,
                                                "1"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("q-tooltip", [
                                            _vm._v(" 개선요청등록 "),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.editable && !_vm.disabled
                                    ? _c(
                                        "q-btn",
                                        {
                                          staticClass: "ColumInnerBtn",
                                          attrs: {
                                            icon: "add",
                                            color: "light-blue",
                                            "text-color": "white",
                                            align: "center",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.innerBtnClicked(
                                                col,
                                                props,
                                                "2"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("q-tooltip", [
                                            _vm._v(" 즉시조치등록 "),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.isOld
                        ? _c("c-btn", {
                            attrs: { label: "개선 전체보기", icon: "help" },
                            on: { btnClicked: _vm.imprDetailPop },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "template",
                { slot: "suffixTitle" },
                [
                  _c(
                    "font",
                    {
                      staticClass: "text-negative",
                      staticStyle: {
                        "font-size": "0.8em",
                        "font-weight": "300",
                      },
                    },
                    [_vm._v(" O : 양호 X : 불량 △ : 요정비 ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "gridImpr",
              attrs: {
                title: "항목외 개선 목록",
                columns: _vm.gridImpr.columns,
                data: _vm.gridImpr.data,
                usePaging: false,
                filtering: false,
                columnSetting: false,
              },
              on: { linkClick: _vm.linkClick2 },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && _vm.popupParam.envPatrolId
                        ? _c("c-btn", {
                            attrs: {
                              label: "개선요청",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addImpr },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.popupParam.envPatrolId
                        ? _c("c-btn", {
                            attrs: {
                              label: "즉시조치",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addiimImpr },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }